import { QueryKey, QueryObserver, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { UsageChartData } from 'src/common/utils/mapUsageDTOtoAreaChartData';

export const useChartDataLastUpdated = (queryKey: QueryKey) => {
  const [lastUpdated, setLastUpdated] = useState<Date>();
  const queryClient = useQueryClient();

  useEffect(() => {
    const observer = new QueryObserver(queryClient, {
      queryKey,
    });
    const unsubscribe = observer.subscribe((result) => {
      const queryResult = result.data as UsageChartData;

      if (queryResult?.lastUpdatedAt) {
        setLastUpdated(new Date(queryResult.lastUpdatedAt));
      }
    });

    return unsubscribe;
  }, []);

  return lastUpdated;
};
